import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { userLoggedOut } from "@WhiteCap/Common/Utillities/CustomTracking";
import { clearRedirectFromEbsSession } from "@WhiteCap/Common/Utillities/EbsRedirectHelper";
import { getSafeRedirectUrl } from "@WhiteCap/Common/Utillities/SafeRedirect";
import { CustomHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
 
export interface SignOutParameter {
    redirectUrl?: string;
}
 
type HandlerType = CustomHandler<SignOutParameter>;
 
export const RedirectToPage: HandlerType = props => {
    if (props.parameter?.redirectUrl) {
        window.location.href = getSafeRedirectUrl(props.parameter.redirectUrl);
        return false;
    }
};
 
export const SendDataLayer: HandlerType = props => {
    const session = getSession(props.getState());
 
    let accountType = "";
    if (session.properties?.isBusinessAccount) {
        accountType = session.properties?.isBusinessAccount.toLowerCase() === "true" ? "Company" : "Personal";
    }
 
    const state = props.getState();
    userLoggedOut({
        event: 'user_logged_out',
        account_type: accountType,
        'user_id': state.context.session?.userName,
    })
};

export const ClearEbsRedirectFlag: HandlerType = () => {
    clearRedirectFromEbsSession();
};

export const ClearCrossDomainRelayFlag: HandlerType = () => {
    sessionStorage.removeItem("crossdomain_relay_sent");
};
 
addToChainBefore(chain, DeleteSession, SendDataLayer);
addToChainBefore(chain, DeleteSession, ClearEbsRedirectFlag);
addToChainBefore(chain, DeleteSession, ClearCrossDomainRelayFlag);
addToChainAfter(chain, DeleteSession, RedirectToPage);